import { useEffect, useRef, useState } from "react"
import { useSearchParams } from "react-router-dom"
import { useBenchmarkReport } from "./benchmarkApi/useBenchmarkReport"
import AboutSection from "./about/AboutSection"
import BenchmarkSearchSection from "./benchmarkSearch/BenchmarkSearchSection"
import CalculatorSection from "./calculator/CalculatorSection"
import CredibilitySection from "./credibility/CredibilitySection"
import DecaySection from "./decay/DecaySection"
import FindingsSection from "./findings/FindingsSection"
// import FinalConverterSection from "./finalConverter/FinalConverterSection"
import LightFooter from "./footer/LightFooter"
import LightHeader from "./header/LightHeader"
import LeaderboardSection from "./leaderboard/LeaderboardSection"
import MethodologySection from "./methodology/MethodologySection"
import SundayGapSection from "./sundayGap/SundayGapSection"
import { contentColumnClass, pageRootClass } from "./lightTheme"
import { useLandingCountry } from "../roofingLight/useLandingCountry"
import {
  countryParamPresent,
  useLandingCountryDetect,
} from "../roofingLight/landingCountryDetect"
import { leadCountryForTestDrive } from "../roofingLight/testDrive/testDriveLead"

export default function RoofingSpeedToLeadBenchmarkLanding() {
  const report = useBenchmarkReport()
  const [searchParams] = useSearchParams()
  const country = useLandingCountry()
  const detection = useLandingCountryDetect()
  const detectionRef = useRef(detection)
  detectionRef.current = detection
  const countryInQuery = countryParamPresent(searchParams)
  const [detectedCountry, setDetectedCountry] = useState(null)

  useEffect(() => {
    if (countryInQuery) {
      setDetectedCountry(null)
      return undefined
    }
    let cancelled = false
    const paramsAtStart = searchParams
    setDetectedCountry(null)
    detectionRef.current.whenSettled().then((code) => {
      if (cancelled) return
      setDetectedCountry(leadCountryForTestDrive(paramsAtStart, code))
    })
    return () => {
      cancelled = true
    }
  }, [countryInQuery])

  const visitorCountry = countryInQuery
    ? leadCountryForTestDrive(searchParams, null)
    : detectedCountry

  return (
    <div
      className="roofing-light-canvas min-h-screen w-full bg-[#FAFAFA]"
      data-country={country || undefined}
      data-visitor-country={visitorCountry || undefined}
    >
      <LightHeader />
      <div className={`${pageRootClass} pt-0`}>
        <div className={contentColumnClass}>
          <CredibilitySection stats={report.stats} statsStatus={report.statsStatus} />
          <MethodologySection
            statsStatus={report.statsStatus}
            totalCompanies={report.stats?.total_companies}
          />
          <BenchmarkSearchSection
            statsStatus={report.statsStatus}
            totalCompanies={report.stats?.total_companies}
          />
          <LeaderboardSection countries={report.countries} />
          <FindingsSection />
          <DecaySection />
          <SundayGapSection />
          <CalculatorSection />
          <AboutSection statsStatus={report.statsStatus} totalCompanies={report.stats?.total_companies} />
          {/*
          <FinalConverterSection
            statsStatus={report.statsStatus}
            totalCompanies={report.stats?.total_companies}
          />
          */}
        </div>
        <LightFooter />
      </div>
    </div>
  )
}
